module.exports = __webpack_public_path__ + "static/media/arrows-vertical.7c468f5e.svg";